export default __webpack_public_path__ + "static/media/background-init.85ffeb88.jpeg";